;(function (angular, _) {
  'use strict'
  angular.module('kilo.routes.dashboard')
    .service('CardCreationService', CardCreationService)

  CardCreationService.$inject = [
    // Angular
    // Libs
    '$uibModal',
    // Managers
    'CardManager'
    // Services
    // Const
    // Resolved
  ]

  function CardCreationService (
    // Angular
    // Libs
    $uibModal,
    // Managers
    CardManager
    // Services
    // Const
    // Resolved
  ) {
    var self = this

    _.extend(self, {
      // Public Attributes
      // Public Method
      configureCard: configureCard
    })

    function configureCard (card) {
      if (!card) {
        card = CardManager.create()
        card.sizeX = 0
        card.sizeY = 0
      }
      return $uibModal.open({
        size: 'lg',
        templateUrl: '/app/modules/dashboard/services/card-creation.template.html',
        resolve: {
          card: [function () {
            return angular.copy(card)
          }]
        },
        controller: 'CardCreationModalController',
        controllerAs: 'ctrl',
        backdrop: 'static'
      }).result
    }
  }
})(window.angular, window._)
